<template>
  <div class="survey-section">
    <h2 class="h2-class">{{ section.name }}</h2>
    <h3 class="h3-class">{{ section.description }}</h3>
    <questions
      v-for="q in section.questions"
      :question="q"
      :key="q.q_id"
      :badQuestions="badQuestions"
      :readOnly="readOnly"
      @emit-value-question="emitValueQuestion"
      @emit-value-age="emitValueQuestion"
    ></questions>
  </div>
</template>

<script>

import Questions from "@/views/Surveys/Question.vue";

export default {
  name: "section",
  components: {
    Questions
  },
  props: {
    section: {
      type: Object,
      default: () => {
        return {};
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitValueQuestion: function(e) {
      //console.log(e);
      this.$emit("emit-value-question", e);
    }
  }
};
</script>
